export default __webpack_public_path__ + "static/national-yards-desktop-37576bf7f33e3f644878a4ce67b757bd.svg";